import { render, staticRenderFns } from "./primary-blue-button.vue?vue&type=template&id=bba86f62&scoped=true&"
import script from "./primary-blue-button.vue?vue&type=script&lang=js&"
export * from "./primary-blue-button.vue?vue&type=script&lang=js&"
import style0 from "./primary-blue-button.vue?vue&type=style&index=0&id=bba86f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba86f62",
  null
  
)

export default component.exports